import useReturnRequestsWithScan from "@babackapp/private-api-client/client/use-get-return-request-with-scan";
import { useFormErrorNotification } from "@babackapp/react-hook-forms-components/form-notifications";
import useTranslation from "@babackapp/translations/use-translation";
import onScan from "onscan.js";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function useScannerMode(props: {
  shopId: string;
  active: boolean;
  runInterceptors?: (code: string) => boolean;
}) {
  const [scanInitiated, setScanInitiated] = useState(false);
  const [searchCode, setSearchCode] = useState("");
  const t = useTranslation();
  const runInterceptorsRef = useRef(props.runInterceptors);

  const { data, error, isPending } = useReturnRequestsWithScan({
    shopId: props.shopId,
    search: searchCode,
  });
  const navigate = useNavigate();
  const errorNotification = useFormErrorNotification({
    title: t("scannerMode.errorNotification.title"),
    message: t("scannerMode.errorNotification.message"),
  });

  useEffect(() => {
    runInterceptorsRef.current = props.runInterceptors;
  });

  useEffect(() => {
    if (data) {
      const returnRequest = data;
      navigate(`/shops/${props.shopId}/returns/${returnRequest.id}`);
    }
    if (error) {
      errorNotification();
    }
    setSearchCode("");
  }, [data]);

  useEffect(() => {
    if (props.active) {
      setScanInitiated(true);
      if (!onScan.isAttachedTo(document)) {
        onScan.attachTo(document, {
          suffixKeyCodes: [13], // enter-key expected at the end of a scan
          reactToPaste: true, // Compatibility to built-in scanners in paste-mode (as opposed to keyboard-mode)
          onScan: async function (sCode: string) {
            if (!runInterceptorsRef.current?.(sCode)) {
              setSearchCode(sCode);
            }
          },
          onKeyDetect: function () {
            // output all potentially relevant key events - great for debugging!
          },
        });
      }
    } else if (scanInitiated) {
      if (onScan.isAttachedTo(document)) {
        onScan.detachFrom(document);
      }
    }
  }, [props.active]);

  return { data, error, isPending };
}
